//collection page load more 

 function initLoadMoreProducts() {
    document.addEventListener('click', function (e) {
      const target = e.target.closest('.itg-load-more a');
      if (target) {
        e.preventDefault();
        const scrollURL = target.getAttribute('href');
        target.classList.add('loading');
        fetch(scrollURL)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelectorAll('#main-collection-product-grid .product-item');
            const grid = document.querySelector('#main-collection-product-grid');
    
            newProducts.forEach(newProduct => {
              const newProductId = newProduct.id;
              if (!document.getElementById(newProductId)) {
                grid.appendChild(newProduct);
                target.classList.remove ('loading');
              }
            });
            const newLoadMore = doc.querySelector('.itg-load-more');
            const currentLoadMore = document.querySelector('.itg-load-more');
            if (newLoadMore) {
              currentLoadMore.innerHTML = newLoadMore.innerHTML;
            } else {
              currentLoadMore.remove();
            }
          });
        }
    });
  }

  initLoadMoreProducts();


// main product page selected variant label show 
document.addEventListener("DOMContentLoaded", function () {
  function attachVariantListeners() {
    document.querySelectorAll("[data-js-product-variant-container]").forEach(container => {
      container.addEventListener("change", function (event) {
        let selectedOption = event.target;
        if (selectedOption.checked) {
          let variantContainer = selectedOption.closest(".product-variant");
          let selectedText = variantContainer.querySelector(".itg_selected_variant");
          if (selectedText) {
            selectedText.textContent = selectedOption.value;
          }
        }
      });
    });
  }

  attachVariantListeners();
  
});


/* product-description*/

const shorts = document.querySelectorAll(".itg_read_more");

shorts.forEach(function(short) {
  short.addEventListener('click', function() {
   // console.log("short clicked");
    const data_short = this.getAttribute('data-desc');
    console.log("Clicked data-desc:", data_short);
    const toggle_tabs = document.querySelectorAll(".toggle");
    toggle_tabs.forEach(function(tab) {
      const data_tab = tab.getAttribute("data-desc");
      console.log("Toggle data-desc:", data_tab);
      if (data_short === data_tab) {
        console.log("Match found!");     
        tab.classList.add("opened");        
        const toggleContent = tab.querySelector(".toggle__content");
        if (toggleContent) {
          toggleContent.style.display = "block";
           tab.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  });
});

var swiper = new Swiper(".mySwiper.bnr_slide-img", {
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  freeMode: true,
});


/* custom video section js */

function toggleVideo() {
  var video = document.getElementById("customVideo");
  var playButton = document.querySelector(".play-button");

  if (video.paused) {
    video.play();
    playButton.classList.add("hidden");
  } else {
    video.pause();
    playButton.classList.remove("hidden");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const video1 = document.getElementById("customVideo");
  const playBtn1 = document.querySelector(".play-button");

  if (video1 && playBtn1) {
    video1.addEventListener("play", function() {
      playBtn1.classList.add("hidden");
    });

    video1.addEventListener("pause", function() {
      playBtn1.classList.remove("hidden");
    });
  }
});